export default {"src":"/_next/static/media/minus.1f12d65e.svg","height":24,"width":24};